import { nanoid } from "nanoid"
import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api, baseURL, superAdminReqConfig } from "../../include/api"
import { CANCELLED, CANCEL_REQUEST, COMPLETED, CONFIRMED, ORDERED, PROCESSED } from "../../include/constant"
import { getSuperAdmin, preventClick, today } from "../../include/function"
import Error from "../add-ons/Error"
import Spinner from "../add-ons/Spinner"
import SuperAdminHeader from "./Header"

const SuperServiceOrders = () => {
    const user = getSuperAdmin()

    const [loading, setLoading] = useState(true)
    const [showFilter, setShowFilter] = useState(false)
    const [serviceOrders, setServiceOrders] = useState([])
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [status, setStatus] = useState('')

    const handleFilter = () => setShowFilter(!showFilter)

    const getServiceOrders = useCallback((afterGet) => {
        setLoading(true)
        api.get('/service_orders/?fromDate=' + fromDate + '&toDate=' + toDate + '&status=' + status, superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setServiceOrders(response.data.data)
                if (afterGet) afterGet()
            }
        }).catch(error => {
            setServiceOrders([])
        }).finally(() => setLoading(false))
    }, [fromDate, status, toDate])

    useEffect(() => {
        if (fromDate !== '' && toDate !== '') {
            getServiceOrders()
        }
    }, [fromDate, getServiceOrders, toDate, user.id])

    useEffect(() => {
        setFromDate(today())
        setToDate(today())
    }, [])

    console.log(serviceOrders);

    return <>
        <SuperAdminHeader >
            <div className="fixed-top-bar">
                <div className="container my-1 mx-1">
                    <div className="row">
                        <div className="col">
                            <h5 className="mb-3">Service Orders</h5>
                        </div>
                        <div className="col text-end">
                            <button className="btn btn-primary d-md-none" onClick={e => preventClick(e, handleFilter)}>
                                <i className="fas fa-filter fa-fw me-2" />
                                <span>Filter</span>
                            </button>
                        </div>
                    </div>
                    <div className={`${!showFilter ? 'd-none' : ''} d-md-block`}>
                        <div className="row my-3">
                            <div className="col-12 col-md-4 mb-3">
                                <label htmlFor="fromDate">From Date</label>
                                <input type="date" className="form-control form-control-lg" name="fromDate" id="fromDate" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <label htmlFor="toDate">To Date</label>
                                <input type="date" className="form-control form-control-lg" name="toDate" id="toDate" value={toDate} onChange={e => setToDate(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <label htmlFor="fromDate">Status</label>
                                <select name="status" className="form-control form-control-lg text-capitalize" id="status" onChange={e => setStatus(e.target.value)} value={status}>
                                    <option value="">All</option>
                                    <option value={ORDERED}>{ORDERED}</option>
                                    <option value={CONFIRMED}>{CONFIRMED}</option>
                                    <option value={PROCESSED}>{PROCESSED}</option>
                                    <option value={COMPLETED}>{COMPLETED}</option>
                                    <option value={CANCEL_REQUEST}>{CANCEL_REQUEST}</option>
                                    <option value={CANCELLED}>{CANCELLED}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {loading ? <div className="py-5"><Spinner color="danger" /></div> :
                        <div className="row">
                            {serviceOrders?.length > 0 ?
                                serviceOrders?.map(order => order.serviceOrderItems.map(item => {
                                    return <Order key={nanoid()} item={item} />
                                })) : <Error mainText="No orders found!" />}
                        </div>}
                </div>
            </div>
        </SuperAdminHeader>
    </>
}

const Order = ({ item }) => {
    return <div className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
        <Link to={"/super/service_order_details/" + item.id} className="text-center d-block p-3 border my-2 text-dark">
            <img className="fit-contain h-100 hover-scale" style={{ minWidth: '50px', maxWidth: '100px' }} src={item.mainImage && baseURL + '/' + item.mainImage} alt="" />
            <h6 className="my-2 text-truncate small">{item.productName}</h6>
            <span className="small me-3">&#8377;{Math.ceil(item.amount)}</span>
            <i className="fas fa-circle fa-fw text-success blink me-1" style={{ fontSize: '.7rem' }} />
            <span className="text-capitalize">{item.status}</span>
        </Link>
    </div>
}

export default SuperServiceOrders